import React, { useEffect } from 'react';
import Mousetrap from 'mousetrap';
import { useLocalStorage, useWindowSize } from '../../util/hooks';
import { addCssClass, removeCssClass } from '../../util/general';

const BurgerMenuButton = () => {
  // Persist user's preference
  const [showMiniMenu, setShowMiniMenu] = useLocalStorage('showMiniMenu', true);
  const windowSize = useWindowSize();

  const toggleMenu = () => {
    const element = document.getElementById('side-bar');
    if (element) {
      const { classList } = element;

      // Mobile behavior
      if (window.innerWidth <= 1024 || classList.contains('disabled')) {

        // Remove mini class if it's there at this size
        removeCssClass(element, 'mini');

        if (classList.contains('open')) {
          removeCssClass(element, 'open');
          return;
        }

        addCssClass(element, 'open');
        return;
      }

      // Other parts of the application may need to know if their parent size changed
      // Timing can be lower if there is no transition animation
      // i.e. Dashboard
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
        if (window.calendar) {
          window.calendar.updateView();
        }
      }, 510);

      if (classList.contains('mini')) {
        setShowMiniMenu(false);
        removeCssClass(element, 'mini');
        return;
      }

      setShowMiniMenu(true);
      addCssClass(element, 'mini');
    }
  };

  useEffect(() => {
    Mousetrap.bind(['`'], toggleMenu);

    return () => {
      Mousetrap.unbind(['`']);
    };
  }, []);

  // In the event the mobile (floating) menu is open when window gets larger, it'll close it
  useEffect(() => {
    if (windowSize.width > 767) {
      const element = document.getElementById('side-bar');
      if (element) {
        removeCssClass(element, 'open');

        if (showMiniMenu) {
          addCssClass(element, 'mini');
        }
      }
    }
  }, [windowSize.width]);

  return (
    <div className="burger-menu-button" onClick={() => toggleMenu()}>
      <i className="zmdi zmdi-menu" />
    </div>
  );
};

export default BurgerMenuButton;
